/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as errors from "../../../../errors/index";
export class BadRequestError extends errors.FlatfileError {
    constructor(body, rawResponse) {
        super({
            message: "BadRequestError",
            statusCode: 400,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, BadRequestError.prototype);
    }
}
